<template>
    <div class="search222 ask-topic">
        <Header
            title=""
            :leftContent="!isWx"
            :rightContent="rightContent"
            :search="true"
            @onChange="getValue"
            ref="searchChild"
        />
        <div class="main">
            <EmptyList v-if="empty" />
            
            <van-list
                v-if="!empty"
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="getValue"
                :immediate-check="false"
            >
                <van-cell class="item" v-for="item in list" :key="item.id" @click="jumpDet(item.id, item.name)">
                    <van-image
                        class="bgimg"
                        lazy-load
                        fit="cover"
                        width="100%"
                        height="100%"
                        :src="item.img"
                    />
                    <span class="bg" :style="{'background-color': item.color }"></span>
                    <div class="info flex flex-column justify-bet">
                        <p class="title van-multi-ellipsis--l2">{{item.name}}</p>
                        <div class="join flex">
                            <span class="flex_1">{{item.ask_num}}个问题</span>
                            <span class="flex_1">{{item.nums}}赞过</span>
                        </div>
                    </div>
                </van-cell>
            </van-list>
        </div>
    </div>
</template>

<script>
import { Header, EmptyList } from "@/components";
import { getAskTopicList } from "@/request/api";
import { checkWx, navigate } from '@/pages/index/custom'

export default {
    components: {
        Header,
        EmptyList
    },
    data() {
        return {
            // 头部参数
            rightContent: {
                text: "搜索"
            },
            // 搜索框内容
            searchValue: "",
            // 最新列表
            list: [],
            loading: false, // 加载中
            finished: false, // 加载完毕
            page: 1,
            empty: false,
            test: require("@/assets/img/live_avatar.jpg")
        };
    },
    methods: {
        // 搜索
        getValue(val) {
            let value = this.$refs.searchChild.searchValue;
            this.list = [];
            this.finished = false;
            getAskTopicList({
                page: this.page,
                pcount: 8,
                keyword: value
            })
            .then(res => {
                let { list, error_code } = res;
                if (error_code === 0) {
                    this.list = res.list;
                    // console.log(this.list)
                    if (this.list.length > 0) {
                        this.empty = false;
                    } else {
                        this.empty = true;
                    }
                    this.finished = true;
                }
            })
            .catch(error => {
                console.log(error);
            });
        },
         // 话题详情
        jumpDet(id, name) {
           navigate({ path: 'askTopicDet', query: { id: id, name: name } });
        },
    },
    created() {
        this.isWx = checkWx();
    }
};
</script>

<style lang="less">
.search {
    width: 100%;
    height: 100%;
    background-color: #f8f8f8;
}
.main {
    padding: 5rem 20px 20px 20px;
    box-sizing: border-box;
}
.main::after {
    content: "";
    display: block;
    clear: both;
}
.search222 {
    .item {
    width: 48%;
    height: 100px;
    border-radius: 6px;
    float: left;
    position: relative;
    &:nth-child(2n) {
        margin-left: 4%;
    }
    .van-image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 6px;
        overflow: hidden;
        z-index: 400;
    }
    .info {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 500;
        box-sizing: border-box;
        padding: .75rem;
        .title {
            font-size: 16px;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            line-height: 22px;
            padding-left: 1.75rem;
            box-sizing: border-box;
            background: url("../../../../../assets/img/icon_msg.png") no-repeat top left;
            background-size: 1.25rem 1.25rem;
        }
        .join {
            font-size:12px;
            font-weight:400;
            color:rgba(255,255,255,1);
        }
    }
    .bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 450;
        opacity: 0.7;
    }
}
.van-list {
    padding-bottom: 30px;
    position: relative;
}
.van-list::after {
    content: "";
    display: block;
    clear: both;
}
}
</style>
